function promiseOnce(fn) {
    let promise = null;
    return (...args) => {
        if (!promise) {
            promise = Promise.resolve(fn(...args));
        }
        return promise;
    };
}

export { promiseOnce };
//# sourceMappingURL=promiseOnce.js.map
